<template>
    <div class="player-bar-area">
        <audio ref="audio"></audio>
        <div class="timer">{{timer}}</div>
        <div class="bar" ref="bar" @mousedown="startDrag">
            <div class="bar-handle" ref="handle" @mousedown="startDrag" :style="`left: ${progressBarPixels}%;`"></div>
        </div>

    </div>
</template>

<script>
    import app from '../App';
    import TimeFormatters from "../../appHelpers/TimeFormatters";

    export default {
        name: "PlayerBar",
        props: ['play', 'stop', 'playUniqueId'],
        data() {
            return {
                currentUniqueId: null,
                currentTime: 0,
                loaded: false,
                durationSeconds: 0,
                playing: false,
                audio: undefined,
                dragging: false,
            }
        },

        methods: {
            load() {
                if (this.audio.readyState >= 2) {
                    this.loaded = true;
                    return this.durationSeconds = parseInt(this.audio.duration);
                }

                throw new Error('Failed to load sound file.');
            },
            startDrag(e) {
                if (e.button !== 0) return;
                window.addEventListener('mousemove', this.drag);
                window.addEventListener('mouseup', this.stopDrag);
            },
            stopDrag(e) {
                window.removeEventListener('mousemove', this.drag);
                window.removeEventListener('mouseup', this.stopDrag);
                this.setCurrentTimeByBarPosition(e.pageX);
            },
            drag(e) {
                this.setCurrentTimeByBarPosition(e.pageX);
            },
            setCurrentTimeByBarPosition(x) {

                const barBound = this.$refs.bar.getBoundingClientRect(),
                    handleWidth = this.$refs.handle.clientWidth;
                const effectiveWidth = barBound.width - handleWidth;
                const value = Math.min(Math.max(x - barBound.left, 0), effectiveWidth) / effectiveWidth;

                this.audio.currentTime = (this.audio.duration * value) || 0
            }
        },
        mounted() {
            this.audio = this.$refs.audio;

            this.audio.addEventListener('timeupdate', () => this.currentTime =  parseInt(this.audio.currentTime, 10));
            this.audio.addEventListener('loadeddata', this.load);
            this.audio.addEventListener('pause', () => { this.playing = false; });
            this.audio.addEventListener('play', () => { this.playing = true; });
        },
        computed: {
            progressBarPixels() {
                return this.currentTime / this.durationSeconds * 100 ;
            },
            streamUrl() {
                return app.apiUrl('recordings/stream', { 'uniqueid': this.currentUniqueId }, false);
            },
            timer() {
                if (!this.audio) return '';
                const currentPosition = this.currentTime || 0;

                return currentPosition + this.durationSeconds > 0 ?
                    `${TimeFormatters.timeFromSeconds(currentPosition)} / ${TimeFormatters.timeFromSeconds(this.durationSeconds)}` :
                    'ERR';
            }
        },
        watch: {
            playUniqueId(uniqueId) {

                this.$refs.audio.src = '';

                this.currentUniqueId = uniqueId;

                if (!uniqueId) return this.playing = false;

                this.$refs.audio.src = this.streamUrl;

                return this.playing = true;

            },
            play(value) {
                this.playing = value
            },
            playing(play) {

                if (play) {
                    return this.audio.play();
                }

                this.audio.pause();

                this.$emit('change', play);

            },
            stop(value) {
                if (!value) return;
                this.playing = false;
                this.audio.currentTime = 0;
            }

        }
    }
</script>

<style scoped>

</style>